import { useEffect, useMemo, useState } from 'react'

import { Presence } from '@radix-ui/react-presence'

import { TutorialStatus, useTutorialStore } from '@wwt/core/tutorial'
import ArrowUpIcon from '@wwt/shared/assets/icons/outline/arrow-upward.svg'

import { Button } from '@/shared/ui/Button'

// FIXME: remove after removal of stacked manager
export interface TopScrollButtonProps {
	isAllowToShow: boolean
}

export const TopScrollButton = () => {
	const [isOpen, setIsOpen] = useState(false)

	const tutorialStatus = useTutorialStore.use.tutorialStatus()

	const isTutorialActive = useMemo(() => {
		return tutorialStatus === TutorialStatus.GOING
	}, [tutorialStatus])

	const isAllowToShow = !isTutorialActive

	const handleTopScroll = () => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		})
	}

	useEffect(() => {
		const halfScreenOffset = window.innerHeight / 2

		const onUserScroll = () => {
			setIsOpen(window.scrollY > halfScreenOffset)
		}

		window.addEventListener('scroll', onUserScroll)
		return () => window.removeEventListener('scroll', onUserScroll)
	}, [])

	const isShowed = useMemo(
		() => (isAllowToShow ? isOpen : false),
		[isAllowToShow, isOpen]
	)

	return (
		<Presence present={isShowed}>
			<Button
				// FIXME: z-index to 100 after removal of chakra-ui
				className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in fixed right-5 bottom-[calc(var(--radix-toast-viewport-height)+1rem)] z-5500 shadow-md sm:right-16 sm:bottom-16 md:size-16 md:[&_svg]:size-9"
				variant="outline"
				size="icon"
				onClick={handleTopScroll}
				data-state={isShowed ? 'open' : 'closed'}
			>
				<ArrowUpIcon />
			</Button>
		</Presence>
	)
}
